import { traverse } from '@shared/ui/utils/global-utils/traverse';
import {
  compose,
  filter,
  includes,
  keys,
  lensProp,
  map,
  mapObjIndexed,
  mergeAll,
  over,
  path,
  prop,
} from 'ramda';

import {
  ContactInformationSection,
  ContactUsCMSDataContract,
  ContactUsDataGroupCMSElement,
  HelpSection,
} from '../../../models/contact-us.models';
import { ContactUsDataGroupMainContent } from './contact-us.type';

export const unwrapComponentMainContent: (
  input: ContactUsCMSDataContract,
) => ContactUsDataGroupMainContent = compose(
  mergeAll as any,
  map((section: ContactUsDataGroupCMSElement) =>
    compose((sectionName: ContactUsDataGroupCMSElement['name']) => {
      const sectionData = path<(ContactInformationSection | HelpSection)[0]>([
        'data',
        sectionName,
        0,
      ])(section);
      const listOfKeysToIgnore = ['h3Title'];
      const listOfKeysToTraverse = ['submitCTA'];
      const keysToProcess = compose(
        filter(
          keyName =>
            !includes(keyName, listOfKeysToTraverse) &&
            !includes(keyName, listOfKeysToIgnore),
        ),
        keys,
      )(sectionData);

      const transformedSectionData = mapObjIndexed((entry, key: string) => {
        if (includes(key, keysToProcess)) {
          const validationLabelsExists = path([0, 'validationLabels'], entry);

          if (validationLabelsExists) {
            return over(lensProp('validationLabels'), path([0]))(entry[0]);
          } else {
            return entry[0] || entry;
          }
        } else if (includes(key, listOfKeysToTraverse)) {
          return traverse(entry[0]);
        }
        return entry;
      })(sectionData);

      return {
        [sectionName]: transformedSectionData,
      };
    }, prop('name'))(section),
  ),
  prop('contactUs'),
);
